exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/modules/_object-gops.js
// module id = 118
// module chunks = 0